import { guidedVisitActive } from './events';
import { loadTour, tourEntryFor } from './tourContent';

/**
 * The tour's own slide on the in-world board, played like every lesson (owner 13 Oct: "did not we generated onboarding's
 * own first slides ... why we are loading the original lesson slide ... We should have a proper way of showing onboarding
 * slide etc at viewboard in the same way"; Sol owner-r27 Q2 A). The board plays a unit file, so each tour course has a
 * copy of its unit file with ONE onboarding lesson first (scripts/first-visit-tour/build-onboarding-units.mjs). While the
 * guided visit runs in that unit's world, the world loads the copy; the tour's Start Lesson plays the onboarding lesson,
 * and its progress is never sent. Every other launch loads the unit's own file, as before.
 */
let onboardingLesson = null;
export const onboardingLessonId = () => onboardingLesson;
export const isOnboardingLessonId = lessonId => /_ONB$/.test(String(lessonId || ''));

/** The two addresses name the same unit file (the last two path parts: Science/4S_P1.json), whatever the host. */
export function sameUnitFile(a, b) {
  const tail = url => {
    try {
      return new URL(String(url)).pathname.split('/').filter(Boolean).slice(-2).join('/').toLowerCase();
    } catch (_) {
      return '';
    }
  };
  const left = tail(a);
  return Boolean(left) && left === tail(b);
}

/** The onboarding copy to load instead of `realUrl`, or null: only when it is a copy of exactly that unit file. */
export function onboardingContentFor(entry, realUrl) {
  const lesson = entry?.onboardingLesson;
  if (!lesson?.unitUrl || !lesson?.lessonId || !realUrl) return null;
  return sameUnitFile(lesson.realUnitUrl, realUrl) ? lesson : null;
}

/** The unit file the world's tutor setup loads: the onboarding copy during the guided visit, else `realUrl`. */
export async function resolveTutorContent(realUrl, { curriculumId, waitMs = 3000 } = {}) {
  onboardingLesson = null;
  if (!realUrl || !curriculumId) return realUrl;
  try {
    const tourLoad = loadTour().catch(() => null);
    const timeout = new Promise(resolve => setTimeout(() => resolve(null), waitMs));
    const [active, tour] = await Promise.all([guidedVisitActive({ timeoutMs: waitMs }), Promise.race([tourLoad, timeout])]);
    const swap = active && tour ? onboardingContentFor(tourEntryFor(tour, curriculumId), realUrl) : null;
    if (!swap) return realUrl;
    onboardingLesson = swap.lessonId;
    return swap.unitUrl;
  } catch (_) {
    return realUrl;
  }
}
